import {Component, forwardRef, Input, OnInit, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {UrlService} from '../../services/url.service';
import {DropzoneComponent} from 'ngx-dropzone-wrapper';
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'files-input',
  templateUrl: './files-input.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilesInputComponent),
      multi: true,
    },
    UrlService
  ]
})
export class FilesInputComponent implements OnInit, ControlValueAccessor {

  @ViewChild('dropzone') private dropzone: DropzoneComponent;

  placeholders = {
    multiple: 'Drop files here or click to upload',
    single: 'Drop file here or click to upload'
  };
  configDefault: any = {
    addRemoveLinks: true,
    timeout: 1500000,
    maxFilesize: 600,
    params: {},
  };
  singleConfig: any = {
    maxFiles: 1,
  };
  config: any = this.configDefault;
  single: boolean = false;
  accepted: string | string[];

  @Input('config') set config$(value) {
    if (value) {
      this.config = Object.assign({}, this.configDefault, value);

      if (this.single) Object.assign(this.config, this.singleConfig);
      if (this.accepted) Object.assign(this.config, {acceptedFiles: this.accepted});
      this.setUrlConfig();
    }
  };
  @Input('single') set single$(value) {
    if (value === undefined) return;

    this.single = value;

    delete this.config.maxFiles;
    this.placeholder = value ? this.placeholders.single : this.placeholders.multiple;

    if (this.single) Object.assign(this.config, this.singleConfig);
  };
  @Input('accepted') set accepted$(value) {
    if (value === undefined) return;

    delete this.config.acceptedFiles;

    this.accepted = value;
    Object.assign(this.config, {acceptedFiles: this.accepted});
  };

  @Input() placeholder: string = this.placeholders.multiple;
  @Input() disabled: boolean;

  localeValue: any = [];

  private onTouched = () => {
  };

  private onChange: (value: any) => void = () => {
  };

  constructor(private _urlService: UrlService,
              private toastrService: ToastrService) {
    this.setUrlConfig();
  }


  setUrlConfig() {
    if (!this.config?.url) {
      this.config.url = this._urlService.uploadProjectAsset();
    }
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  maxFilesExceeded() {
    this.toastrService.error('You can\'t upload more than one file.', 'Error');
  }

  registerOnChange(onChange: (value: any) => void) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: () => void) {
    this.onTouched = onTouched;
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  init = false;
  writeValue(value: any) {
    this.localeValue = Array.isArray(value) ? value : [value];

    if (value && !this.init) {
      const dropzone = this.dropzone.directiveRef.dropzone();
      this.localeValue.forEach(item => {
        if (dropzone.files.find(file => file.id === item.id)) return

        const imagesFormat = ['png', 'jpg', 'jpeg', 'bmp', 'svg', 'webp', 'gif'];
        const file = {
          name: item.name || item.Key,
          url: item.Location,
          id: item.id,
          status: 'success',
          accepted: true
        };

        dropzone.emit('addedfile', file);

        if (imagesFormat.some(item => file.url?.includes(`.${item}`))) {
          dropzone.emit('thumbnail', file, file.url);
        }

        dropzone.emit('complete', file);

        dropzone.files.push(file);
      });
      this.init = true;
    }
  }

  upload($event) {
    if (this.single) {
      this.localeValue = [$event[1]];
    } else if (Array.isArray(this.localeValue)) {
      this.localeValue.push($event[1]);
    } else {
      this.localeValue = [$event[1]];
    }

    this.change();
  }

  change() {
    this.onChange(this.single ? (this.localeValue[0] || null) : this.localeValue);
  }

  remove($event) {
    if (!this.localeValue) return;

    try {
      const id = $event.id || JSON.parse($event?.xhr?.response)?.id;
      if (id && id.toString()) {
        const findIndex = this.localeValue.findIndex(item => item.id == id);

        this.localeValue.splice(findIndex, 1);

        this.change();
      }
    } catch(e) {}
  }
}
